import Vue from "vue";
import Vuex from "vuex";
import "es6-promise/auto";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    culture:"nl-NL",
    selectedProperties: {
      rcValue: "",
      length: 0,
      width: 0,
      supportPoints: 3,
      roofSurfaces: 2
    },
    rcWaardenCombipakken: [],
    supportPointOptions: [2, 3, 4, 5],
    formData: {
      companyName: "",
      name: "",
      email: "",
      phoneNumber: "",
      addressStreet: "",
      addressZipcode: "",
      addressCity: "",
      termsAccepted: false
    },
    defaultAeroSafeFoamPistols: 1,
    rcValueMapping: {
      "0,27": "3,5",
      "0,24": "4",
      "0,21": "4,5",
      "0,19": "5",
      "0,18": "5,5",
      "0,16": "6",
      "0,14": "7",
      "0,12": "8",
      "0,11": "9",
      "0,10": "10"
    }
  },
  mutations: {
    SET_PROPERTY(state, payload) {
      state.selectedProperties[payload.property] = payload.data;
    },
    SET_FORM_DATA(state, payload) {
      state.formData[payload.property] = payload.data;
    },
    SET_CULTURE(state, payload) {
      state.culture = payload;
    },
    SET_COMBIPAK(state, payload) {
      state.rcWaardenCombipakken = payload;
    }
  },
  getters: {
    isCultureNl(state) {
      return state.culture === "nl-NL"
    },
    isFrenchCulture(state) {
      return state.culture == "fr-BE"
    },
    privacyUrl(state) {
      if (state.culture == "nl-BE") return "https://www.kingspan.com/be/nl/privacyverklaring-website/";
      else if (state.culture == "fr-BE") return "https://www.kingspan.com/be/fr/politique-de-confidentialite-du-site-internet/";
      else return "https://www.kingspan.com/nl/nl/privacyverklaring-website/";
    },
    totalSquaredMeters(state) {
      return (
        Number(
          (state.selectedProperties.roofSurfaces *
            (state.selectedProperties.length *
              state.selectedProperties.width)) /
            1000000
        ) || 0
      );
    },
    totalSquaredMetersAsString(state) {
      return (
        Number(
          (state.selectedProperties.roofSurfaces *
            (state.selectedProperties.length *
              state.selectedProperties.width)) /
            1000000
        ).toLocaleString("nl-NL", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) || 0
      );
    },
    additionalScrews(state) {
      if (state.selectedProperties.length <= 5999) return 0;
      else if (state.selectedProperties.length <= 7499) return 2;
      else if (state.selectedProperties.length <= 8000) return 3;
      return 0;
    },
    combipak(state) {
      return state.rcWaardenCombipakken.find(
        x => x.rc === state.selectedProperties.rcValue
      ).combipak;
    },
    squaredMetersPerElement(state) {
      return Number((state.selectedProperties.length * 1020) / 1000000) || 0;
    },
    squaredMetersPerElementAsString(state) {
      return (
        Number(
          (state.selectedProperties.length * 1020) / 1000000
        ).toLocaleString("nl-NL", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) || 0
      );
    },
    totalRoofElements(state, getters) {
      return (
        Math.ceil(
          Number(getters.totalSquaredMeters) /
            Number(getters.squaredMetersPerElement)
        ) || 0
      );
    },
    screwCount(state, getters) {
      return (
        getters.totalRoofElements * state.selectedProperties.supportPoints * 3 +
        getters.totalRoofElements * getters.additionalScrews
      );
    },
    boxesOfScrews(state, getter) {
      return Math.ceil(getter.screwCount / 50);
    },
    additionalScrewSpacerOriginal(state, getter) {
      return getter.totalRoofElements * getter.additionalScrews;
    },
    additionalScrewSpacerCount(state, getter) {
      return Math.round(
        Math.ceil(getter.additionalScrewSpacerOriginal / 100.0) * 100
      );
    },
    ldProfilesInMM(state) {
      return Math.ceil(state.selectedProperties.length / 1000) * 1000;
    },
    ldProfilesCount(state, getter) {
      return Math.ceil(getter.totalRoofElements / 5) * 5;
    },
    geficellBandM1(state, getter) {
      return getter.totalRoofElements * 1.02 * 2;
    },
    geficellBandCount(state, getter) {
      return Math.ceil(getter.geficellBandM1 / 25);
    },
    aerosafeFoamCannisterCount(state, getter) {
      return Math.ceil(
        ((getter.totalRoofElements + 1) *
          (Number(state.selectedProperties.length) / 1000)) /
          14
      );
    },
    aerosafeFoamPistolValue(state) {
      return state.defaultAeroSafeFoamPistols;
    },
    roofElementType(state) {
      if (state.culture == "nl-BE" || state.culture == "fr-BE") {
        return `Unidek Aero Comfort ${state.rcValueMapping[state.selectedProperties.rcValue]}`;

      } else {
        if (typeof state.selectedProperties.rcValue === "number") {
          return `Unidek Aero ${Number(state.selectedProperties.rcValue).toFixed(
            1
          )}`;
        }

        return `Unidek Aero ${state.selectedProperties.rcValue}`;
      }
    },
    rcValuesOptions(state) {
      return state.rcWaardenCombipakken.map(x => x.rc);
    },
    jsonViewModel(state, getter) {
      var pdfProductName;
      if (state.culture == 'nl-BE')
        pdfProductName = `Unidek Aero Comfort ${state.rcValueMapping[state.selectedProperties.rcValue]}`;
      else if (state.culture == 'fr-BE')
        pdfProductName = `Unidek Aero Confort ${state.rcValueMapping[state.selectedProperties.rcValue]}`;
      else
        pdfProductName = `Unidek Aero ${state.selectedProperties.rcValue}`;

      return {
        formData: {
          ...state.formData, productName: pdfProductName
        },
        selectedProperties: state.selectedProperties,
        calculation: {
          totalSquaredMeters: getter.totalSquaredMetersAsString,
          totalRoofElements: getter.totalRoofElements,
          squaredMetersPerElement: `${getter.squaredMetersPerElementAsString} m²`,
          combipak: getter.combipak,
          boxesOfScrews: getter.boxesOfScrews,
          additionalScrewSpacerCount: getter.additionalScrewSpacerCount,
          ldProfilesCount: getter.ldProfilesCount,
          geficellBandCount: getter.geficellBandCount,
          aerosafeFoamCannisterCount: getter.aerosafeFoamCannisterCount,
          defaultAeroSafeFoamPistols: getter.aerosafeFoamPistolValue
        }
      };
    }
  }
});
